import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { GetInternalOrdersInputDto, InternalOrderCreateDto, InternalOrderDto, InternalOrderExcelDownloadDto, InternalOrderUpdateDto } from '../dtos/internal-order/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class InternalOrderService {
  private restService = inject(RestService);
  apiName = 'Controlling';
  

  create = (input: InternalOrderCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, InternalOrderDto>({
      method: 'POST',
      url: '/api/controlling/internalOrders',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/controlling/internalOrders/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/controlling/internalOrders',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, InternalOrderDto>({
      method: 'GET',
      url: `/api/controlling/internalOrders/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/controlling/internalOrders/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetInternalOrdersInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<InternalOrderDto>>({
      method: 'GET',
      url: '/api/controlling/internalOrders',
      params: { name: input.name, sapCode: input.sapCode, isVisible: input.isVisible, costCenterId: input.costCenterId, costCenterName: input.costCenterName, internalOrderTypeId: input.internalOrderTypeId, internalOrderTypeName: input.internalOrderTypeName, projectTypeId: input.projectTypeId, oldCostCenterId: input.oldCostCenterId, oldCostCenterName: input.oldCostCenterName, oldSapCode: input.oldSapCode, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: InternalOrderExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/controlling/internalOrders/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, sapCode: input.sapCode, isVisible: input.isVisible, costCenterId: input.costCenterId, costCenterName: input.costCenterName, internalOrderTypeId: input.internalOrderTypeId, internalOrderTypeName: input.internalOrderTypeName, projectTypeId: input.projectTypeId, oldCostCenterId: input.oldCostCenterId, oldCostCenterName: input.oldCostCenterName, oldSapCode: input.oldSapCode, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, InternalOrderDto[]>({
      method: 'GET',
      url: '/api/controlling/internalOrders/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: InternalOrderUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, InternalOrderDto>({
      method: 'PUT',
      url: `/api/controlling/internalOrders/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}